import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { AuthService } from 'src/app/services';
import { HighlightService } from 'src/app/services/highlight.service';
import { Role } from 'src/app/shared/models/role.model';

@Component({
  selector: 'getting-started',
  templateUrl: './getting-started.component.html',
  styleUrls: ['./getting-started.component.less']
})
export class GettingStartedComponent implements OnInit {

  script: string = "<script src='https://view.situsystems.com/v2/situsystems-situview.js'></script>";
  codePenScriptUrl: string = "https://cpwebassets.codepen.io/assets/embed/ei.js";
  isSituDeveloper: boolean = false;
  highlighted: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private renderer: Renderer2,
    private authService: AuthService,
    private highlightService: HighlightService) {
  }

  ngOnInit() {
    this.isSituDeveloper = this.authService.isAuthorized([Role.SituSystemsDeveloper]);
    this.appendScript(this.codePenScriptUrl);
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  private appendScript(url: string) {
    let scriptElement = this.renderer.createElement("script");
    scriptElement.type = "text/javascript";
    scriptElement.src = url;
    this.renderer.appendChild(this.document.body, scriptElement);
  }
}
